<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
      <tr>
        <th>Name</th>
        <th>Messages available</th>
        <th>Messages in flight</th>
        <th>Messages delayed</th>
        <th>Messages in dead queue</th>
        <th>Default visibility timeout (Seconds)</th>
        <th>Created at</th>
        <th>Updated at</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="queue in queues" :key="queue.id">
        <td>
          {{ queue.queueName }}
          <CopyIcon @click="copy(queue.queueFullName)"
                    style="cursor: pointer"
                    class="fd-icon ml-2"
                    size="1.5x"
                    v-tooltip.right="'Copiar nome completo'"/>
        </td>
        <td>{{ queue.ApproximateNumberOfMessages }}</td>
        <td>{{ queue.ApproximateNumberOfMessagesNotVisible }}</td>
        <td>{{ queue.ApproximateNumberOfMessagesDelayed }}</td>
        <td :class="{ 'dead-queue': queue.deadQueue.ApproximateNumberOfMessages > 0 }">
          {{ queue.deadQueue.ApproximateNumberOfMessages }}
        </td>
        <td>{{ queue.VisibilityTimeout }}</td>
        <td>{{ toDate(queue.CreatedTimestamp) | datetime }}</td>
        <td>{{ toDate(queue.LastModifiedTimestamp) | datetime }}</td>
      </tr>
    </tbody>
    <tfoot v-if="this.queues.length > 0">
      <tr>
        <td class="info-queue-message" colspan="8">
          <strong>{{ info }}</strong>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
  import { CopyIcon } from 'vue-feather-icons'
  
  export default {
    components: { CopyIcon },
    computed: {
      info() {
        if (this.queues.length === 0)
          return '-'
        
        return {
          'message in dead queue': this.messagesDeadQueue,
          'messages available': this.messagesAvailable,
          'messages delayed': this.messagesDelayed,
          'messages in flight': this.messagesInFlight
        }
      },
      messagesAvailable() {
        if (this.queues.length === 0)
          return 0
        
        return this.queues.map(queue => parseInt(queue.ApproximateNumberOfMessages))
                   .reduce((a, b) => a + b)
      },
      messagesDeadQueue() {
        return this.queues.map(queue => parseInt(queue.deadQueue.ApproximateNumberOfMessages) || 0)
                   .reduce((a, b) => a + b)
      },
      messagesDelayed() {
        return this.queues.map(queue => parseInt(queue.ApproximateNumberOfMessagesDelayed))
                   .reduce((a, b) => a + b)
      },
      messagesInFlight() {
        return this.queues.map(queue => parseInt(queue.ApproximateNumberOfMessagesNotVisible))
                   .reduce((a, b) => a + b)
      }
    },
    methods: {
      copy(value) {
        const input = document.createElement('input');
        input.value = value
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      },
      toDate(timestamp) {
        return new Date(timestamp * 1000)
      }
    },
    name: 'Table',
    props: {
      queues: { required: true, type: Array }
    }
  }
</script>

<style scoped>
 .dead-queue {
   color: red;
   font-weight: bold;
 }
 
 .info-queue-message {
   background: gray
 ;
 }

</style>